// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import util from '../../../../share/util/utils';
import session from '../../../../share/session';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../../../share/src/util/api/polling';
import { apiErrorDefaultAction } from '../../../../share/util/api/errorAction';

/** メッセージ内の置き換え文字列定義 */
const DID = '$DID$';

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  FAILURE_JUDGMENT_DISPLAY: 'failureJudgmentDisplay',
  LIFT_UP: 'liftUp',
  HEAT_COOL: 'heatCool',
  HEAT_COOL2: 'heatCool2',
  SUCCESS: 'success',
  WAIT: 'wait',
  FAILURE: 'failure',
  IGOFF: 'igoff',
  IGOFF_WAIT: 'igoffWait',
  EGI_START: 'egiStart',
  BRAKE_STEP_ON: 'brakeStepOn',
  P_RANGE_SELECT: 'pRangeSelect',
  P_RANGE_MAINTAIN: 'pRangeMaintain',
  D_RANGE_SELECT: 'dRangeSelect',
  BRAKE_PEDAL_OPEN: 'brakePedalOpen',
  AWD_CONTROL: 'awdControl',
  D_RANGE_LEARNING: 'dRangeLearning',
  CLUTCH_CONTROL: 'clutchControl',
  SHIFT_D_RANGE: 'shiftDRange',
  R_RANGE_SELECT: 'rRangeSelect',
  SHIFT_R_RANGE: 'shiftRRange',
  N_RANGE_SELECT: 'nRangeSelect',
  STOP_IGOFF: 'stopIgoff',
  STOP_IGOFF_WAIT: 'stopIgoffWait',
  STOP_EGI_START: 'stopEgiStart',
  ERROR: 'error',
  FAILED: 'failed'
};

export default {
  name: 'requirement024',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      buttonDisabled: false,
      displayInfo: '',
      inputMsg: '',
      waitTime: 0,
      systemId: '',
      isCanceled: false,

      // ダイアログフラグ
      modal_requirement_024: false
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  components: {
    // 無し
  },

  computed: {
    /** ダイアログのヘッダー色 */
    // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
    /* eslint-disable complexity */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILURE_JUDGMENT_DISPLAY:
        case PHASE.FAILURE:
        case PHASE.FAILED:
        case PHASE.ERROR:
          return 'danger';
        case PHASE.SUCCESS:
          return 'success';
        case PHASE.LIFT_UP:
        case PHASE.HEAT_COOL:
        case PHASE.HEAT_COOL2:
        case PHASE.START:
        case PHASE.WAIT:
        case PHASE.IGOFF:
        case PHASE.IGOFF_WAIT:
        case PHASE.EGI_START:
        case PHASE.P_RANGE_SELECT:
        case PHASE.D_RANGE_SELECT:
        case PHASE.P_RANGE_MAINTAIN:
        case PHASE.BRAKE_STEP_ON:
        case PHASE.BRAKE_PEDAL_OPEN:
        case PHASE.AWD_CONTROL:
        case PHASE.D_RANGE_LEARNING:
        case PHASE.CLUTCH_CONTROL:
        case PHASE.SHIFT_D_RANGE:
        case PHASE.R_RANGE_SELECT:
        case PHASE.SHIFT_R_RANGE:
        case PHASE.N_RANGE_SELECT:
        case PHASE.STOP_IGOFF:
        case PHASE.STOP_IGOFF_WAIT:
        case PHASE.STOP_EGI_START:
        default:
          return 'secondary';
      }
    },

    ...mapState({
      language: state => state.systems.language,
      netAppId: state => state.netAppConnector.pairingAppId
    }),
  },

  methods: {

    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      this.modal_requirement_024 = true;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_024 = false;
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      this.isLoading = false;
      // 異常終了：エラー表示
      this.phase = PHASE.FAILED;
      return;
    },

    /** 個別エラー画面の表示 */
    showErrorScreen(result) {
      this.phase = PHASE.ERROR;
      switch (result) {
        case 'dtc_error':
          // DTC検出の表示画面へ遷移
          this.displayInfo = this.i18nWsKey + '.REQ_WS_24_TXT_23';
          break;
        case 'atf_error':
          // ATF油温異常の表示画面へ遷移
          this.displayInfo = this.i18nWsKey + '.REQ_WS_24_TXT_24';
          break;
        case 'engine_error':
          // エンジン回転数異常の表示画面へ遷移
          this.displayInfo = this.i18nWsKey + '.REQ_WS_24_TXT_25';
          break;
        case 'brake_error':
          // ブレーキOFF状態が指定時間経過の表示画面へ遷移
          this.displayInfo = this.i18nWsKey + '.REQ_WS_24_TXT_26';
          break;
        case 'shift_error':
          // 指定以外のシフトレンジの表示画面へ遷移
          this.displayInfo = this.i18nWsKey + '.REQ_WS_24_TXT_27';
          break;
        case 'speed_error':
          // 後輪車速異常の表示画面へ遷移
          this.displayInfo = this.i18nWsKey + '.REQ_WS_24_TXT_28';
          break;
        case 'turbine_error':
          // タービン回転数異常の表示画面へ遷移
          this.displayInfo = this.i18nWsKey + '.REQ_WS_24_TXT_29';
          break;
        case 'solenoid_error':
          // ソレノイドへの電流/電圧異常の表示画面へ遷移
          this.displayInfo = this.i18nWsKey + '.REQ_WS_24_TXT_30';
          break;
        case 'learning_error':
          // 学習値許容範囲外の表示画面へ遷移
          this.displayInfo = this.i18nWsKey + '.REQ_WS_24_TXT_31';
          break;
        case 'gear_error':
          // 変速比異常の表示画面へ遷移
          this.displayInfo = this.i18nWsKey + '.REQ_WS_24_TXT_32';
          break;
        default:
          // 異常終了の表示画面へ遷移
          this.displayInfo = this.i18nWsKey + '.REQ_WS_24_TXT_22';
          break;
      }
    },

    /**
    * API 通信で共通バリデーションでエラーが発生した際のコールバック
    * @param {object} result handler.validate で返ってきたバリデーション結果
    */
    validateErrorResult(result) {
      apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        // result を使って、任意の処理をすることも可能
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /**
     * 暖機・冷却運転指示でキャンセルを押下した場合の処理
     * @param {*} existence 0:エラー遷移あり, 1:エラー遷移なし
     */
    async cancelOilTemperature(existence) {
      this.isCanceled = true;
      await this.exit(existence);
    },

    /**
     * Exit処理
     * @param {*} existence 0:エラー遷移あり, 1:エラー遷移なし
     * @returns
     */
    async exit(existence) {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'exit'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (existence === 0) {
          // エラー遷移あり
          if (response) {
            // 正常コールバック
            switch (response.data.status) {
              case REQUEST_STATUS_COMPLETED:
                // 正常終了：機能終了
                this.closeWizard();
                break;
              case REQUEST_STATUS_FAILED:
              default:
                // 異常終了：汎用エラー
                this.showUnexpectedError();
                return;
            }
          }
        } else {
          // エラー遷移なし：機能終了
          this.closeWizard();
          return;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 仮故障判定 */
    async failureProcess() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-trouble_judge'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // 作業サポートで使用するポーリング間隔/回数のデフォルト値と同じ設定になるため、ポーリング間隔/回数の値を指定しない
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // ATF油温判定処理
                  await this.aftOilTemperatureJudgement();
                  break;
                case 'ng':
                  // 仮故障表示画面へ遷移
                  this.phase = PHASE.FAILURE_JUDGMENT_DISPLAY;
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** ATF油温判定 */
    async aftOilTemperatureJudgement() {
      try {
        // キャンセル処理が発生していた場合は、APIを終了する
        if (this.isCanceled) {
          return;
        }
        this.isLoading = true;
        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-oil_judge'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // リフトアップ指示画面表示へ遷移
                  this.phase = PHASE.LIFT_UP;
                  break;
                case 'ng': {
                  // 暖機・冷却運転指示画面へ遷移
                  let replaceMessage = this.$t(`${this.i18nWsKey}.REQ_WS_24_TXT_2`).replace(DID, response.data.user_data.atf_temperature.lower_limit);
                  replaceMessage = replaceMessage.replace(DID, response.data.user_data.atf_temperature.upper_limit);
                  replaceMessage = replaceMessage.replace(DID, response.data.user_data.atf_temperature.current_value);
                  this.inputMsg = replaceMessage;
                  this.phase = PHASE.HEAT_COOL;
                  // 作業サポートのポーリング間隔の時間分sleep
                  await util.sleep(process.env.VUE_APP_WORK_SUPPORT_RETRY_INTERVAL);
                  // ATF油温判定
                  await this.aftOilTemperatureJudgement();
                  break;
                }
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 学習値クリア */
    async learningValueClear() {
      // 監視画面へ遷移
      this.displayInfo = this.i18nWsKey + '.REQ_WS_24_TXT_4_0001';
      this.phase = PHASE.WAIT;
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'execute'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // IG OFF指示画面(1)へ遷移
                  this.phase = PHASE.IGOFF;
                  // IGOFFデータ読出し
                  await this.readIgoff();
                  break;
                case 'ng':
                  // 失敗画面へ遷移
                  this.phase = PHASE.FAILURE;
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** IGOFFデータ読出し */
    async readIgoff() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-ig_off'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // IGOFF待ち画面表示へ遷移
                  this.phase = PHASE.IGOFF_WAIT;
                  // IGOFF待ちデータ読出し
                  await this.readIgoffWait();
                  break;
                case 'ng':
                  // 失敗画面へ遷移
                  this.phase = PHASE.FAILURE;
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** IGOFF待ちデータ読出し */
    async readIgoffWait() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-ig_off_wait'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // OKボタン非活性化
                  this.buttonDisabled = false;
                  // エンジン始動指示画面へ遷移
                  this.phase = PHASE.EGI_START;
                  // エンジン始動指示データ読出し
                  await this.readEgi();
                  break;
                case 'err':
                  // 作業サポートのポーリング間隔の時間分sleep
                  await util.sleep(process.env.VUE_APP_WORK_SUPPORT_RETRY_INTERVAL);
                  // IGOFF待ちデータ読出し
                  await this.readIgoffWait();
                  break;
                case 'ng':
                  // 失敗画面へ遷移
                  this.phase = PHASE.FAILURE;
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
              // 失敗画面へ遷移
              this.phase = PHASE.FAILURE;
              break;
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * エンジン始動指示データ読出し
     * エンジン始動指示(1)とエンジン始動指示(2)で共通使用
     */
    async readEgi() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-engine_start',
            has_timeout: true
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // OKボタン活性化
              this.buttonDisabled = true;
              break;
            case REQUEST_STATUS_FAILED:
              // 異常終了：異常終了の表示画面へ遷移
              this.showErrorScreen('error');
              break;
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },



    /** 仮故障確認処理 */
    async egiStartProcess() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read_with_session_transition-trouble_verify'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // ATF油温確認
                  await this.aftOilTemperatureCheck();
                  break;
                case 'ng':
                  // 仮故障表示画面へ遷移
                  this.phase = PHASE.FAILURE_JUDGMENT_DISPLAY;
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 異常終了：共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** ATF油温確認 */
    async aftOilTemperatureCheck() {
      try {
        // キャンセル処理が発生していた場合は、APIを終了する
        if (this.isCanceled) {
          return;
        }
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-oil_confirm'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // ブレーキ踏み込み指示画面へ遷移
                  this.phase = PHASE.BRAKE_STEP_ON;
                  // ブレーキ踏み込み指示データ読出し
                  await this.readBrakeStepOn();
                  break;
                case 'ng': {
                  // 暖機・冷却運転指示画面(2)へ遷移
                  let replaceMessage = this.$t(`${this.i18nWsKey}.REQ_WS_24_TXT_2`).replace(DID, response.data.user_data.atf_temperature.lower_limit);
                  replaceMessage = replaceMessage.replace(DID, response.data.user_data.atf_temperature.upper_limit);
                  replaceMessage = replaceMessage.replace(DID, response.data.user_data.atf_temperature.current_value);
                  this.inputMsg = replaceMessage;
                  this.phase = PHASE.HEAT_COOL2;
                  // 作業サポートのポーリング間隔の時間分sleep
                  await util.sleep(process.env.VUE_APP_WORK_SUPPORT_RETRY_INTERVAL);
                  // ATF油温確認
                  await this.aftOilTemperatureCheck();
                  break;
                }
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 異常終了：共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** ブレーキ踏み込み指示データ読出し */
    async readBrakeStepOn() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-brake'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了：学習準備データ書込み
              await this.writeLearningPreparationData();
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 異常終了：共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 学習準備中データ書込み */
    async writeLearningPreparationData() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'write-pre'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // ウェイト時間取得(Pレンジ維持指示画面で使用)
              this.waitTime = response.data.user_data.wait_time;
              // 正常終了：Pレンジ指示画面へ遷移
              this.phase = PHASE.P_RANGE_SELECT;
              break;
            case REQUEST_STATUS_FAILED:
              // 異常終了：Dレンジ指示画面へ遷移
              this.phase = PHASE.D_RANGE_SELECT;
              // Dレンジセレクト指示データ読出し
              await this.readDRangeSelect();
              break;
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** Pレンジ維持指示 */
    async pRangeMaintainProcess() {
      // Pレンジ維持指示画面へ遷移
      this.phase = PHASE.P_RANGE_MAINTAIN;
      this.isLoading = true;
      // 指定時間計測
      await util.sleep(this.waitTime);
      this.isLoading = false;
      // Dレンジセレクト指示画面へ遷移
      this.phase = PHASE.D_RANGE_SELECT;
      // Dレンジセレクト指示データ読出し
      await this.readDRangeSelect();
    },

    /** Dレンジセレクト指示データ読出し */
    async readDRangeSelect() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-d_select'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了：AirSSM書込み
              await this.writeAirSsm();
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** AirSSM書込み */
    async writeAirSsm() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'write-air'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了：AirLeakStep書込み
              await this.writeAirLeakStep();
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** AirLeakStep書込み */
    async writeAirLeakStep() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'write-air_leak'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 指定時間計測
              await util.sleep(this.waitTime);
              // 正常終了：AT学習準備画面へ遷移
              this.displayInfo = this.i18nWsKey + '.REQ_WS_24_TXT_11';
              this.phase = PHASE.WAIT;
              // 学習準備データ読出し
              await this.readStudyPreparation();
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 学習準備データ読出し */
    async readStudyPreparation() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-pre_at'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // AWD制御学習データ読出し
                  await this.readAwdControl();
                  break;
                default:
                  this.showErrorScreen(response.data.user_data.result);
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** AWD制御学習データ読出し */
    async readAwdControl() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-awd'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // ブレーキ開放指示画面へ遷移
                  this.phase = PHASE.BRAKE_PEDAL_OPEN;
                  // ブレーキペダル開放指示データ読出し
                  await this.readBrakePedalOpen();
                  break;
                case 'ng':
                  // 出力クラッチ制御学習を実行
                  await this.readOutputClutchControl();
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** ブレーキペダル開放指示データ読出し */
    async readBrakePedalOpen() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-brake_off'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // AWD制御学習中表示画面へ遷移
                  this.phase = PHASE.AWD_CONTROL;
                  // AWD制御学習中表示データ読出し
                  await this.readAwdControlLearning();
                  break;
                default:
                  this.showErrorScreen(response.data.user_data.result);
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** AWD制御学習中表示データ読出し */
    async readAwdControlLearning() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-awd_learning'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // 出力クラッチ制御学習データ読出し
                  await this.readOutputClutchControl();
                  break;
                default:
                  this.showErrorScreen(response.data.user_data.result);
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 出力クラッチ制御学習データ読出し */
    async readOutputClutchControl() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-pre_clutch'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // ブレーキペダル踏み込み指示画面へ遷移
                  this.phase = PHASE.BRAKE_STEP_ON;
                  // ブレーキペダル踏み込み指示読出し
                  await this.readBrakePedalStepOn();
                  break;
                case 'ng':
                  // Dレンジ学習中画面へ遷移
                  this.phase = PHASE.D_RANGE_LEARNING;
                  // Dレンジ学習中表示データ読出し
                  await this.readDRangeLeading();
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
              // Dレンジ学習中画面へ遷移
              this.phase = PHASE.D_RANGE_LEARNING;
              // Dレンジ学習中表示データ読出し
              await this.readDRangeLeading();
              break;
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** ブレーキペダル踏み込み指示読出し */
    async readBrakePedalStepOn() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-brake_pedal'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // 出力クラッチ制御学習中画面へ遷移
                  this.phase = PHASE.CLUTCH_CONTROL;
                  // 出力クラッチ制御学習中表示データ読出し
                  await this.readOutputClutchControlLeading();
                  break;
                default:
                  this.showErrorScreen(response.data.user_data.result);
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 出力クラッチ制御学習中表示データ読出し */
    async readOutputClutchControlLeading() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-clutch'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // Dレンジ学習中表示画面へ遷移
                  this.phase = PHASE.D_RANGE_LEARNING;
                  // データ読出し
                  await this.readDRangeLeading();
                  break;
                default:
                  this.showErrorScreen(response.data.user_data.result);
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** Dレンジ学習中表示データ読出し */
    async readDRangeLeading() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-d_learning'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // シフト制御学習中表示（Dレンジ）画面へ遷移
                  this.phase = PHASE.SHIFT_D_RANGE;
                  // シフト制御学習中表示（Dレンジ）データ読出し
                  await this.readShiftDRange();
                  break;
                default:
                  this.showErrorScreen(response.data.user_data.result);
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** シフト制御学習中表示（Dレンジ）データ読出し */
    async readShiftDRange() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-shift_d_learning'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // Rレンジセレクト指示画面へ遷移
                  this.phase = PHASE.R_RANGE_SELECT;
                  // Rレンジセレクト指示データ読出し
                  await this.readRRangeSelect();
                  break;
                default:
                  this.showErrorScreen(response.data.user_data.result);
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** Rレンジセレクト指示データ読出し */
    async readRRangeSelect() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-r_select'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // シフト制御学習中表示（Rレンジ）画面へ遷移
                  this.phase = PHASE.SHIFT_R_RANGE;
                  // シフト制御学習中表示（Rレンジ）データ読出し
                  await this.readShiftRRange();
                  break;
                default:
                  this.showErrorScreen(response.data.user_data.result);
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** シフト制御学習中表示（Rレンジ）データ読出し */
    async readShiftRRange() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-shift_r_learning'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // Nレンジセレクト指示画面へ遷移
                  this.phase = PHASE.N_RANGE_SELECT;
                  // Nレンジセレクト指示データ読出し
                  await this.readNRangeSelect();
                  break;
                default:
                  this.showErrorScreen(response.data.user_data.result);
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** Nレンジセレクト指示データ読出し */
    async readNRangeSelect() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-n_select'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了：IGOFF指示(2)画面へ遷移
              this.phase = PHASE.STOP_IGOFF;
              // IGOFF指示(2)データ読出し
              await this.readStopIgoff();
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** IGOFF指示(2)データ読出し */
    async readStopIgoff() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-ig_off'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // 正常終了:IGOFF待ち(2)画面へ遷移
                  this.phase = PHASE.STOP_IGOFF_WAIT;
                  // IGOFF待ち(2)データ読出し
                  await this.readStopIgoffWait();
                  break;
                case 'ng':
                  // 共通エラー画面へ遷移
                  this.showUnexpectedError();
                  return;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** IGOFF待ち(2)データ読出し */
    async readStopIgoffWait() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-ig_off_wait'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // OKボタン非活性化
                  this.buttonDisabled = false;
                  // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
                  /* eslint-disable max-depth */
                  if (this.phase !== PHASE.ERROR) {
                    // エンジン始動指示(2)へ遷移
                    this.phase = PHASE.STOP_EGI_START;
                  }
                  // エンジン始動指示(2)データ読出し
                  await this.readEgi();
                  break;
                case 'err':
                  // 作業サポートのポーリング間隔の時間分sleep
                  await util.sleep(process.env.VUE_APP_WORK_SUPPORT_RETRY_INTERVAL);
                  // IGOFF待ち(2)データ読出し
                  await this.readStopIgoffWait();
                  break;
                case 'ng':
                  // 共通エラー画面へ遷移
                  this.showUnexpectedError();
                  return;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },



    /** 確認処理 */
    async confirmationProcess() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-confirmation'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // 正常終了の表示画面へ遷移
                  this.phase = PHASE.SUCCESS;
                  break;
                case 'ng':
                  // 異常終了の表示画面へ遷移
                  this.showErrorScreen('error');
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },

  async mounted() {
    this.init();
  },
};